/**
 * Koppen met een woord dat te lang is voor de breedte (bv. "ONS
 * HERFSTASSORTIMENT" op een smartphone) braken midden in het woord af:
 * "HERFSTASSORTI / MENT". Horizon schaalt grote koppen wel mee, maar nooit
 * kleiner dan 3rem, en een vaste kleinere maat lost het niet op voor elk
 * woord dat Dierendonck later intypt of koppelt (collectienamen).
 *
 * Dit script verkleint zo'n kop net genoeg tot het langste woord past.
 * Koppen die al passen blijven ongemoeid; groter wordt er niets.
 */
(() => {
  const SELECTOR = '.text-block :is(h1, h2, h3)';
  const MIN_FONT_SIZE = 18;

  function fit(heading) {
    heading.style.removeProperty('font-size');
    if (!heading.clientWidth) return;

    // Zonder overflow-wrap loopt een te lang woord buiten de kop; dat is
    // precies wat we willen meten.
    heading.style.overflowWrap = 'normal';
    let size = parseFloat(getComputedStyle(heading).fontSize);

    for (let i = 0; i < 4 && heading.scrollWidth > heading.clientWidth + 1 && size > MIN_FONT_SIZE; i++) {
      size = Math.max(MIN_FONT_SIZE, Math.floor((size * heading.clientWidth) / heading.scrollWidth));
      heading.style.fontSize = `${size}px`;
    }

    heading.style.removeProperty('overflow-wrap');
  }

  function fitAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(fit);
  }

  let resizeFrame;
  let lastWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    // Enkel bij een andere breedte: op mobiel vuurt resize ook bij het
    // in- en uitschuiven van de adresbalk.
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => fitAll());
  });

  // In de theme-editor worden secties opnieuw geladen zonder paginaherlaad.
  document.addEventListener('shopify:section:load', (event) => fitAll(event.target));

  const start = () => (document.fonts ? document.fonts.ready.then(() => fitAll()) : fitAll());
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
